import { Button, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@stores/auth.store';

const { Title, Paragraph } = Typography;

const AppHome = () => {
    const navigate = useNavigate();
    const user = useAuthStore((s) => s.user);
    const logout = useAuthStore((s) => s.logout);

    const handleSignOut = async () => {
        await logout();
        navigate('/sign-in', { replace: true });
    };

    return (
        <div style={{ padding: 32, maxWidth: 560 }}>
            <Title level={3}>Signed in</Title>
            <Paragraph>
                {user?.email ? `Signed in as ${user.email}.` : 'You are signed in.'}
            </Paragraph>
            <Button type="primary" onClick={handleSignOut}>
                Sign out
            </Button>
        </div>
    );
};

export default AppHome;
